import { render } from "./ModalImpersonationUserCountry.vue?vue&type=template&id=67db74c6"
import script from "./ModalImpersonationUserCountry.vue?vue&type=script&lang=js"
export * from "./ModalImpersonationUserCountry.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__